import { render, staticRenderFns } from "./recordText.vue?vue&type=template&id=bf845d60&scoped=true"
import script from "./recordText.vue?vue&type=script&lang=js"
export * from "./recordText.vue?vue&type=script&lang=js"
import style0 from "./recordText.vue?vue&type=style&index=0&id=bf845d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf845d60",
  null
  
)

export default component.exports